import { sendTosaRequest } from './sendTosaRequest';
import validateZipcodeQuery from './validateZipcode.graphql';

import type {
  ValidateZipcodeQuery,
  ValidateZipcodeQueryVariables,
} from './types';

type Mutation = ValidateZipcodeQuery;
type Variables = ValidateZipcodeQueryVariables;

interface ValidateZipCodeInput {
  zip: string;
}

export async function validateZipcode({ zip }: ValidateZipCodeInput) {
  const response = await sendTosaRequest<Variables, Mutation>({
    query: validateZipcodeQuery,
    variables: {
      zipcode: zip,
    },
  });

  return response;
}
